export const selectSubscriptionPlan = (state) => state.Planslist;
